import * as React from "react";
import i18n from "../../../../i18n/i18n";
import {Popup} from "../popup/popup";
import {ReactComponent as AllowPopupIcon} from "../../../../statics/icons/icon_entryOrExitAllowPopup.svg";
import {ReactComponent as NotAllowPopupIcon} from "../../../../statics/icons/icon_entryOrExitNotAllowPopup.svg";
import {HttpError} from "../httpError/httpError";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../models/httpError";
import {Api} from "../../../../helpers/api";
import DropDown from "../dropDown/dropDown";
import {LocationDropDownEntryModel} from "../../../../topology/models/location";
import {DropDownModel} from "../../../models/dropDown";
import {DropDownUtils} from "../../../../helpers/dropDownUtils";
import "./allowOrNotAllowPopup.scss";
import {ValidatedValue} from "../../../../helpers/validatedValue";
import {TransportationService} from "../../../../transportation/services/transportationService";

interface AllowOrNotAllowProps {
    popupType: "allowPopup" | "notAllowPopup" | "assignWagonsNumberPopup" | "openAllPopup" | "closeAllPopup" | null;
    confirm: () => void;
    closePopup: () => void;
    isOrderPopup: boolean;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    selectedLocation: ValidatedValue<string | null>;
    orderType?: "order" | "ticket";
    locationName?: string;
    isEntryLocationType?: boolean;
    orderId?: string;
    onChangeDropdown?: (newValue: any) => void;
    isDownloadLocations: boolean;
    isWaiting?: boolean;
}

interface AllowOrNotAllowState {
    locations: LocationDropDownEntryModel[];
    locationsResponse: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

export default class AllowOrNotAllowPopup extends React.Component <AllowOrNotAllowProps, AllowOrNotAllowState> {
    constructor(props: any) {
        super(props);

        this.state = {
            locations: [],
            locationsResponse: undefined
        };
    }

    async componentDidMount() {
        const locationsResponse = this.props.isDownloadLocations ? await TransportationService.getEntryOrExitLocationsForDropDown() : undefined;

        this.setState({
            locations: (Api.isSuccess(locationsResponse) && locationsResponse && locationsResponse.data) ? locationsResponse.data : [],
            locationsResponse
        });
    }

    public get isAllowPopup() {
        return this.props.popupType === "allowPopup";
    }

    public get isOrder() {
        return this.props.orderType === "order";
    }

    public render(): JSX.Element {
        const className = this.isAllowPopup ? "allow-popup" : "not-allow-popup popup-with-secondary-button-color";
        const icon = this.isAllowPopup ? <AllowPopupIcon/> : <NotAllowPopupIcon/>;
        const testId = this.isAllowPopup ? "allow-popup" : "not-allow-popup";

        return (
            <Popup
                open={this.props.popupType !== null}
                className={className}
                header={this.renderHeader()}
                secondHeader={this.renderHeader()}
                icon={icon}
                content={this.renderContent()}
                actionText={i18n.t(`${this.props.popupType}.actionText`)}
                action={this.props.confirm}
                cancel={this.props.closePopup}
                testId={testId}
                httpError={this.renderErrors()}
                isWaiting={this.props.isWaiting}
            />
        );
    }

    private renderHeader() {
        return (
            i18n.t(`${this.props.popupType}.${
                this.props.isOrderPopup ?
                    "headerWithOrder" :
                    this.props.isEntryLocationType ? "headerEntry" : "headerExit"
            }`)
        );
    }

    private renderContent() {
        const {selectedLocation, popupType, isOrderPopup, isEntryLocationType, locationName, onChangeDropdown} = this.props;
        const locationTestId = popupType === "allowPopup" ? "allow-location" : "not-allow-location";

        if (isOrderPopup) {
            return (
                <div>
                    {i18n.t(`${popupType}.contentEntry`)}
                    {i18n.t(`${popupType}.contentEntryWithOrder`, {orderText: i18n.t(`${popupType}.${this.isOrder ? "order" : "ticket"}`)})}
                    <div>
                        <b>{this.props.orderId}</b>
                        <DropDown
                            className="selected-location"
                            label={i18n.t("locationDropdownLabel")}
                            validatedValue={selectedLocation}
                            items={this.locationsToDropDownMap()}
                            testId={locationTestId}
                            onChange={onChangeDropdown}
                            isLoader={this.state.locations.length < 0}
                        />
                    </div>
                </div>
            );
        } else {
            const content = isEntryLocationType ? "contentEntry" : "contentExit";

            return (
                <div>
                    {i18n.t(`${popupType}.${content}`)}
                    {i18n.t(`${popupType}.${content}WithoutOrder`)}
                    <b>{locationName}</b>
                </div>
            );
        }
    }

    private renderErrors() {
        const {orderId, isEntryLocationType, isOrderPopup, popupType, locationName, response} = this.props;

        const orderType = i18n.t(`${popupType}.errors.${this.isOrder ? "orderError" : "ticketError"}`);
        let causeError = "";

        if (isOrderPopup) {
            causeError = i18n.t(`${popupType}.errors.${
                this.isAllowPopup ? "allowEntryWithOrderErrorSuffix" : "notAllowEntryWithOrderErrorSuffix"
            }`, {orderId: orderId, orderType: orderType});
        } else {
            const contentError = isEntryLocationType ? "EntryErrorSuffix" : "ExitErrorSuffix";

            causeError = i18n.t(`${popupType}.errors.${
                this.isAllowPopup ? "allow" : "notAllow"
            }${contentError}`, {locationName: locationName});
        }

        return (
            <>
                {!Api.isSuccess(response) && (
                    <HttpError
                        response={response}
                        cause={causeError}
                    />
                )}
            </>
        );
    }

    private locationsToDropDownMap(): DropDownModel[] {
        return DropDownUtils.listToDropDownMap(this.state.locations, "id");
    }
}
